import { client } from '../../../shared/services/apiClient';
import { ValidHashResponse } from '../../models/reset-password/ResetPassword';

export const reset = async (hash: string, data: URLSearchParams): Promise<any> => {
  return client(false, false).put<URLSearchParams>(`/auth/change-password/${hash}`, data);
};

export const validateHash = async (hash: string): Promise<ValidHashResponse> => {
  return client(false, false)
    .get(`/auth/validate-hash/${hash}`)
    .then((response) => response.data);
};
